/*
 * Copyright (c) 2026 Helvia Technologies PC <contact@helvia.io>
 */

import { useEffect, useState } from 'react';
import { t } from 'i18next';
import { Result, Typography } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';

const SharePointConsentCallbackScreen = () => {
  const [status, setStatus] = useState('processing');
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const tenantId = params.get('tenant');
    const adminConsent = params.get('admin_consent');
    const error = params.get('error');
    const errorDescription = params.get('error_description');

    if (error) {
      setStatus('error');
      setErrorMessage(errorDescription || error);
      return;
    }

    if (tenantId && adminConsent === 'True' && window.opener) {
      window.opener.postMessage(
        { type: 'sharepoint-consent', tenantId },
        window.location.origin
      );
      setStatus('success');
      setTimeout(() => window.close(), 1500);
      return;
    }

    if (tenantId && adminConsent === 'True') {
      setStatus('success');
      return;
    }

    setStatus('error');
    setErrorMessage(t('Unexpected response from Azure AD.'));
  }, []);

  if (status === 'processing') {
    return null;
  }

  if (status === 'success') {
    return (
      <Result
        icon={<CheckCircleOutlined style={{ color: '#52c41a' }} />}
        title={t('Authorization granted')}
        subTitle={
          <Typography.Text type="secondary">
            {t('You can close this window and return to the integration form.')}
          </Typography.Text>
        }
      />
    );
  }

  return (
    <Result
      icon={<CloseCircleOutlined style={{ color: '#ff4d4f' }} />}
      title={t('Authorization failed')}
      subTitle={
        <Typography.Text type="secondary">
          {errorMessage}
        </Typography.Text>
      }
    />
  );
};

export default SharePointConsentCallbackScreen;
